// extracted by mini-css-extract-plugin
module.exports = {"article-title":"news-detail_article-title__yvYh6","article-content":"news-detail_article-content__9qyp6"};